import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import { StyleSheetManager } from 'styled-components';
import stylisPluginLogicalCss from '../../stylis_plugin_logical_css/stylis_plugin_logical_css.js';
import { Theme } from '../Theme/Theme.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];

var ThemeLegacy = function ThemeLegacy(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(StyleSheetManager, {
    stylisPlugins: [stylisPluginLogicalCss],
    children: /*#__PURE__*/jsx(Theme, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }))
  });
};

ThemeLegacy.propTypes = {
  "children": _PropTypes.node
};
ThemeLegacy.displayName = "ThemeLegacy";

export { ThemeLegacy };
